import React from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-forge bg-paper" data-id="element-99" data-mp="4mi3fau9loeh">
      <p className="flex items-center justify-center gap-1.5 bg-ink px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-gold" data-id="element-100" data-mp="4jvv38zjv4v7">
        <HammerIcon size={12} aria-hidden="true" data-id="element-101" data-mp="xa4hjd14cbfl" />
        Método de aprendizaje paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-102" data-mp="sai2qz5n6n4o">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-anton text-[1.85rem] uppercase leading-[1.05] text-ink sm:text-5xl" data-id="element-103" data-mp="ncgkuhjyctus">
          El sistema completo para aprender{' '}
          <span className="text-forge underline decoration-gold decoration-4 underline-offset-4" data-id="element-104" data-mp="3j7zgfm2d3yi9">
            herrería y fabricar muebles industriales
          </span>{' '}
          desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-steel sm:text-base" data-id="element-105" data-mp="39b4l1c1dye87">
          Aprendé a trabajar con hierro y madera, fabricar tus propios muebles
          industriales y prepararte para ofrecer trabajos por encargo —{' '}
          <strong className="font-bold text-ink" data-id="element-106" data-mp="2qlenwia5hgd4">
            sin perderte entre cientos de videos, herramientas y tutoriales.
          </strong>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.1
      }} className="mt-2.5 inline-block rounded-md bg-ink px-3 py-1.5 text-xs font-black uppercase leading-tight tracking-wide text-gold" data-id="element-107" data-mp="2hincujl6smm0">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2.5 block overflow-hidden rounded-xl border-4 border-ink bg-white" data-id="element-108" data-mp="ibozop5huuwh">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-109" data-mp="161jbd3e2udf5" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.18
      }} className="mt-3" data-id="element-110" data-mp="x1ecjhmy8ncl">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-111" data-mp="3hqu105yp3zz2">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-steel" data-id="element-112" data-mp="1xacgp6hknput">
            <span className="flex items-center gap-1" data-id="element-113" data-mp="21b63fwja2ym4">
              <ZapIcon size={12} className="text-forge" data-id="element-114" data-mp="269hcw65nv73t" />
              Acceso Digital Inmediato
            </span>
            <span className="text-steel/50" data-id="element-115" data-mp="2b1ra8793v9g4">•</span>
            <span className="flex items-center gap-1" data-id="element-116" data-mp="2b2kbwtt7j8re">
              <ShieldCheckIcon size={12} className="text-forge" data-id="element-117" data-mp="2fz0vrbtdj0yo" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}